export default __webpack_public_path__ + "media/images/front/about/snscheck_pc-7db887a04a118594b6f0b7d294556866.png";